<template>
  <v-select
    :return-object="false"
    :items="options"
    v-model="innerValue"
    :clearable="!readonly"
    item-text="text"
    item-value="value"    
    @blur="emitBlur"
    hide-details
    label="Status"
    @change="emitChange"
    dense
    x-small
    v-bind="resetProps"
    :disabled="disabled"
    :readonly="readonly"
  />
</template>

<script>
export default {
  props: {
    items: Array,
    value: String,
    disabled: Boolean,
    readonly: Boolean
  },
  watch: {
    value(n) {
      this.innerValue = n;
    },
    innerValue(value) {
      this.$emit("input", value);
    },
  },
  computed: {
    resetProps() {
      return { ...this.$attrs };
    },
  },

  methods: {
    emitBlur() {
      this.$emit("blur");
    },
    emitChange() {
      this.$emit("change");
    },
  },
  data() {
    return {
      innerValue: this.value,
      options: [
        {
          text: "Available",
          value: "available",
        },
        {
          text: "Open",
          value: "open",
        },
        {
          text: "In Progress",
          value: "inprogress",
        },
        {
          text: "Canceled",
          value: "canceled",
        },
        {
          text: "Completed",
          value: "completed",
        }
      ],
    };
  },
};
</script>